<template>
  <Layout style="background: #21343b">
    <h2 slot="title" class="text-center" style="color: white">{{ $t('createWorkspace') }}</h2>
    <p slot="desc" class="desc text-center mb-0">{{ $t('createWorkspaceDesc') }}</p>
    <v-form slot="content" ref="createWsForm" class="text-center mt-15" @submit.prevent="setCreateWs" lazy-validation>
      <v-container>
        <v-row>
          <v-col class="pt-0 pb-0 text-center">
            <v-avatar :color="wsName | iconBackground" class="logo" rounded size="80">
              <span class="white--text text-h3" style="color: white" v-if="!wsLogo">
                {{ wsName | iconFilter }}
              </span>
              <img :src="wsLogo" v-else />
            </v-avatar>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="logo pt-0 pb-0 mt-3 mb-11 text-center">
            <label for="logo" style="color: white">{{ $t('addLogo') }}</label>
            <input type="file" id="logo" @change="setWsLogo" />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0 text-left">
            <label for="wsName" class="text-left" style="color: white">
              {{ $t('workspaceName') }}
            </label>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-text-field
              outlined
              dense
              dark
              ref="wsName"
              id="wsName"
              :placeholder="'My Workspace'"
              :rules="[rules.required(wsName, 'wsName')]"
              hide-details="auto"
              validate-on-blur
              v-model="wsName"
              @keyup="checkVal(0, $refs.wsName.hasError)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0 mt-5 text-left">
            <label for="wsDomain" class="text-left" style="color: white">
              {{ $t('workspaceDomain') }}
            </label>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-text-field
              prefix="www.tape.ooo/"
              outlined
              dense
              dark
              ref="wsDomain"
              id="wsDomain"
              placeholder="myworkspace"
              :rules="[rules.required(wsDomain, 'wsDomain'), rules.min(wsDomain)]"
              :error="!(isCheckingWsDomain || isAvailableDomain === null || isAvailableDomain)"
              :error-messages="
                isCheckingWsDomain || isAvailableDomain === null || isAvailableDomain
                  ? ''
                  : $t('msgWorkspaceDomainNotAvailable')
              "
              hide-details="auto"
              validate-on-blur
              v-model="wsDomain"
              @keyup="
                replaceWsDomain()
                checkWsDomain()
              "
            >
              <template v-slot:append>
                <v-progress-circular
                  v-if="wsDomain.length > 1 && isCheckingWsDomain"
                  color="primary"
                  :width="3"
                  size="24"
                  indeterminate
                ></v-progress-circular>
                <v-icon color="primary" v-if="wsDomain.length > 1 && !isCheckingWsDomain && isAvailableDomain">
                  mdi-check
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0 mt-5 text-left">
            <label for="wsTeamType" class="text-left" style="color: white">{{ $t('wsTeamType') }}</label>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-select
              :items="wsTeamTypeList"
              :item-text="$i18n.locale"
              item-value="code"
              outlined
              dense
              dark
              ref="wsTeamType"
              id="wsTeamType"
              :placeholder="$t('msgSelectWsTeamType')"
              hide-details
              v-model="wsTeamType"
              @change="checkVal(2, $refs.wsTeamType.hasError)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0 mt-5">
            <v-btn
              block
              elevation="0"
              height="40"
              :disabled="!isBtnAble || isCheckingWsDomain || isLoading"
              :loading="isLoading"
              :class="'btn-' + ((isBtnAble && !isCheckingWsDomain) || isLoading ? 'able' : 'disable')"
              id="continue"
              @click="setCreateWs"
            >
              {{ $t('continue') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="showMsg">
          <v-col class="pt-0 pb-0 mt-5">
            <v-alert dense outlined>
              <span v-html="errorMessage" />
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Onboarding'
import { fill } from 'lodash'
import { isNull } from '@/common/lib/strLib'
import { mapState } from 'vuex'
import { chkWsDomain, setCreateWs, setFileUpload } from '@/services/api'

export default {
  name: 'CreateWorkspace',
  components: {
    Layout,
  },
  created() {
    this.valChkArray = fill(Array(3), false)

    this.$store.dispatch('setFirebaseLog', {
      eventName: 'screen_view',
      eventParam: {
        firebase_screen: '워크스페이스 생성',
        firebase_screen_class: 'Create',
      },
    })
  },
  data: () => ({
    wsLogo: '',
    wsName: '',
    wsDomain: '',
    isAvailableDomain: null,
    isCheckingWsDomain: false,
    wsTeamType: '',
    valChkArray: [],
    isBtnAble: false,
    isLoading: false,
    showMsg: false,
    errorCode: '',
    errorMessage: '',
    backgroundColor: '',
  }),
  computed: {
    // wsNameFirstChar() {
    //   return this.wsName ? this.wsName.toUpperCase().charAt(0) : ''
    // },
    rules() {
      let vm = this

      return {
        required: (value, type) => !isNull(value) || vm.$t('msgEnter' + type.charAt(0).toUpperCase() + type.slice(1)),
        min: (value) => value.length > 1 || vm.$t('msgWorkspaceNameMinLength'),
      }
    },
    ...mapState({
      wsTeamTypeList: (state) => state.service.policyList.wsTeamType,
    }),
  },
  methods: {
    setWsLogo(e) {
      // TODO: 모달창으로 설정하도록 변경 필요
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
    },
    // TODO: common library로 이동
    createImage(file) {
      var reader = new FileReader()
      reader.onload = async (e) => (this.wsLogo = await this.resizeImage(e.target.result))
      reader.readAsDataURL(file)
    },
    // TODO: common library로 이동
    resizeImage(base64Str, maxWidth = 160, maxHeight = 160) {
      return new Promise((resolve) => {
        let img = new Image()
        img.src = base64Str
        img.onload = () => {
          let canvas = document.createElement('canvas')
          const MAX_WIDTH = maxWidth
          const MAX_HEIGHT = maxHeight
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }
          canvas.width = width
          canvas.height = height
          let ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          resolve(canvas.toDataURL())
        }
      })
    },
    checkVal(index, result) {
      this.valChkArray.splice(index, 1, !result)
      this.isBtnAble = !this.valChkArray.includes(false)
    },
    // TODO: common library
    replaceWsDomain() {
      this.wsDomain = this.wsDomain.replace(/[^a-z0-9-]/gi, '')
      this.wsDomain = this.wsDomain.toLowerCase()
    },
    async checkWsDomain(wsDomain = this.wsDomain) {
      if (this.timer) {
        this.isCheckingWsDomain = false
        this.isAvailableDomain = null
        this.checkVal(1, !this.isAvailableDomain)
        clearTimeout(this.timer)
        this.timer = null
      }
      if (!isNull(wsDomain) && wsDomain.length > 1) {
        this.timer = setTimeout(async () => {
          try {
            this.isCheckingWsDomain = true
            let result = await chkWsDomain(this, wsDomain)

            this.isAvailableDomain = result.body.isCanUse
            this.checkVal(1, !this.isAvailableDomain)
          } catch (error) {
            console.log(error.response.status, error.response.data)
          } finally {
            this.isCheckingWsDomain = false
          }
        }, 1500)
      }
    },
    async setCreateWs() {
      this.isLoading = true
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      if (!this.$refs.createWsForm.validate()) return false

      try {
        let result = await setCreateWs(this, this.wsName, this.wsDomain, this.wsTeamType)
        if (this.wsLogo) {
          // wsLogo S3 업로드

          let parallellUploads = await setFileUpload(this, this.wsLogo, 'wsLogo', result.wsId)
          parallellUploads.on('httpUploadProgress', () => {
            // ctx.progressValue = Math.floor(100 / (progress.total / progress.loaded))
          })
          await parallellUploads.done()
          result.wsLogo = `https://file.tape.ooo/wsLogo/${result.wsId}.png`
        }

        await this.$store.dispatch('getUserWsList', result.wsLogo)
        this.$store.getters.userWsList[0].wsLogo = result.wsLogo
        this.$router.push({
          name: 'InviteWorkspace',
          params: {
            passedWsId: result.wsId,
            passWsName: result.wsName,
            passedWsDomain: result.wsDomain,
            passedWsLogo: result.wsLogo,
          },
        })
      } catch (error) {
        this.errorCode = typeof error.response !== 'undefined' ? error.response.data : error.message

        this.errorMessage = this.$t('msg' + this.errorCode.charAt(0).toUpperCase() + this.errorCode.slice(1))

        console.log(this.errorCode, this.errorMessage)

        this.showMsg = true
      } finally {
        this.isCheckingWsDomain = false
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.logo label {
  display: inline;
  border-bottom: 1px solid transparent;
  cursor: pointer;
}

.logo label:hover {
  border-bottom: 1px solid #666;
}

.logo input {
  width: 0;
  height: 0;
  line-height: 0;
  font-size: 0;
  text-indent: -9999px;
}

.logo img {
  display: block;
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: cover;
}
</style>
